module.exports = __webpack_public_path__ + "img/quick_grip.50a1f6d4.jpg";